import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './ConfirmationIcon.styled';

/**
 * Success Icon that renders a white Check icon centered inside a green Hexagon glyph
 */
const ConfirmationIcon = ({ size }) => (
  <Styled.ConfirmationIcon $size={size}>
    <Styled.Hexagon $size={size} />
    <Styled.Icon name="check" size={size === 'large' ? 28 : 12} $size={size} />
  </Styled.ConfirmationIcon>
);

ConfirmationIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'large'])
};

ConfirmationIcon.defaultProps = {
  size: 'small'
};

export default ConfirmationIcon;
